import { translation as t } from 'consts'

function loadTranslations({ output, services, state, input }) {
  let locale = null
  const { selectedLocale, name } = state.get('client')
  if (input.option) {
    locale = input.option.key
  } else {
    locale = selectedLocale
  }
  services.client.translate
    .init(t.URL, t.system, locale, t.namespaces, name)
    .then(translation => {
      return output.true({ translation })
    })
    .catch(output.false)
}

loadTranslations.async = true
loadTranslations.outputs = ['true', 'false']
export default loadTranslations



// WEBPACK FOOTER //
// ./src/modules/app/actions/loadTranslations.js